import { NgModule } from '@angular/core';
import { EntityDataService, EntityServices } from '@ngrx/data';
import {CamJobModel} from "./api/entity/camJob.model";
import {CamJobRepository} from "./impl/service/repository/camJob.repository";
import {CamJobDataService} from "./impl/service/repository/camJobData.service";

@NgModule({
})
export class CamJobModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: CamJobRepository,
                dataService: CamJobDataService) {
        entityDataService.registerServices({
            CamJob: dataService,
        });

        entityServices.registerEntityCollectionServices({
            CamJob: repository,
        });
    }
}

